import React, { Component } from 'react'
// import Tabs from '../tabs/tabs';
import '../../utils/stylesheets/layout/layout.css'
import Toolbar from '../../components/toolbar/toolbar';
import { connect } from 'react-redux';
import Tabs from '../tabs/insurance_tabs'
import constants from '../../utils/constants/apiconstant';
// import InsuranceReport from '../../containers/insurance/insureanceReport';
import InsuranceReport from '../insurance/insurancereport'
import { withStyles } from '@material-ui/core/styles';
import { scrollToTopPage } from '../../utils/commonfunction';
const styles = (theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "10% 80% 10%",
    marginTop: "2%",
    // [theme.breakpoints.down("920")]: {
    //   marginTop: "30%",
    // },
    // [theme.breakpoints.down("600")]: {
    //    marginTop: "55%",
    // }
  }
})
class Insurance_Layout extends Component {

  componentDidMount() {
    scrollToTopPage()
  }


  componentDidUpdate(prevProps) {
    const { clientID, date, location } = this.props;
    if (prevProps.location != location) {
      // 
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <div >
        <Toolbar title={constants.Common.Insurance} childFunc={this.props.childFunc} ></Toolbar>

        <div className={classes.root}>
          <div ></div>
          <div >
            <Tabs page={this.props.location} />
          </div>
          <div ></div>
        </div>


      </div>
    )
  }
}
const mapStateToProps = state => ({
  date: state.Login.date,
  mfHeader2: state.Card.Insurance,
  sessionID: state.Login.sessionID,
  clientID: state.Login.logindetails.ClientID,
  userID: state.Login.userID,
  date: state.Login.date,
  logindetails: state.Login.logindetails
})
export default withStyles(styles)(connect(mapStateToProps, null)(Insurance_Layout))